<template>
  <b-tab title="Tedarikçi ürünleri" active>
    <b-row class="border">
      <b-col cols="2">
        Tedarikçi
      </b-col>
      <b-col cols="2">
        Stok Adedi
      </b-col>
      <b-col cols="2">
        Fiyat
      </b-col>
    </b-row>
    <b-row v-for="supplierProduct in supplierProducts" :key="supplierProduct.id" class="border">
      <b-col cols="2">
        {{ supplierProduct.supplier.name }}
      </b-col>
      <b-col cols="2">
        {{ supplierProduct.stock }}
      </b-col>
      <b-col cols="2">
        {{ supplierProduct.price }}
      </b-col>
    </b-row>
  </b-tab>
</template>
<script>
export default {
  name: "SupplierProductTab",
  props: {
    product: {
      type: Object,
      required: true
    },
    supplierProducts: {
      type: Array,
      required: true
    }
  }
}
</script>